export const CITY_RINK_DEFAULT_BUTTON_COLOR = '#c6e300';
export const CITY_RINK_DEFAULT_BUTTON_TEXT_COLOR = '#000000';
export const CITY_RINK_DEFAULT_BUTTON_URL = 'https://cityrink.culturemap.com/';

export const shouldHydratePromoAlert = (requestedId, publicationId, hydratedId) =>
  Boolean(requestedId && publicationId === requestedId && hydratedId !== requestedId);

export const getPromoAlertPublicationValues = (publication, isCityRink) => ({
  ...publication,
  ...(isCityRink
    ? {
        style: 'City Rink',
        buttonColor: publication?.buttonColor || CITY_RINK_DEFAULT_BUTTON_COLOR,
        buttonTextColor: publication?.buttonTextColor || CITY_RINK_DEFAULT_BUTTON_TEXT_COLOR,
      }
    : {}),
});

export const getPromoAlertTemplateId = (siteId, style, findTemplate) =>
  siteId && style ? findTemplate(siteId, style)?.id : undefined;

export const buildPromoAlertData = (digest, { id, isCityRink, dallasId }) => ({
  ...digest,
  id: digest.id || id,
  style: isCityRink ? 'City Rink' : digest.style,
  siteId: isCityRink ? dallasId : digest.siteId,
  buttonUrl: digest.buttonUrl,
  buttonColor: isCityRink ? digest.buttonColor || CITY_RINK_DEFAULT_BUTTON_COLOR : digest.buttonColor,
  buttonTextColor: isCityRink
    ? digest.buttonTextColor || CITY_RINK_DEFAULT_BUTTON_TEXT_COLOR
    : digest.buttonTextColor,
  trendingNews: digest.trendingNews || [],
  trendingEvents: digest.trendingEvents || [],
  trendingPlaces: digest.trendingPlaces || [],
});
